import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
  CreateSubject ({ state }, course) {
    let obj = course
    return new Promise((resolve, reject) => {
      axios.post('subject/createSubject', obj)
        .then(response => {
          resolve(response.data)
          course = {}
        }).catch((err) => {
          reject(err)
        })
    })
  },
  GetSubjectList ({ state, commit }) {
    axios.get('subject/getSubjectlist')
      .then(response => {
        state.subjectList = response.data
        commit('setSubjectList', response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  }

}
